/**
 * app-configuration-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class AppConfigurationRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_CFG_APP;
	public static tag : MessageTag = MessageTag.REQ_CFG_APP;

    public verifyReply (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_CFG_APP);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/app-configuration-request.ts